<script>
  export var settings;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";
  import Upgrade from './Upgrade.svelte';
  import { from } from "./from";
  import { uuidv4 } from "./utils.js";

  function createQuery() {
    settings.queries = [...(settings.queries || []), {
      id: uuidv4(),
      name: "New query",
      sql: "select 1",
    }]
  }

  var results={};
  var tried=false;

  function execQuery(query, callback) {
    from("/query", {method:"POST",body:JSON.stringify(query)})
    .then(resp => resp.json())
    .then(json => {
      console.log(json);
      results[query.id] = json.results
      if (callback) {
        callback();
      }
    });
  }
  function download(query) {
    // bit hacky - better to download from server via redirect?
    if (!results[query.id] && tried === false) {
      tried = true;
      execQuery(query, ()=>{ download(query); });
    } else {
      tried = false;
  
      let csv = "";
      let rows = results[query.id].ResultSet.Rows;
      rows.forEach(row => {
        row.Data.forEach((cell,i) => {
          let value = Object.values(cell)[0];
          csv += value === undefined ? "" : value;
          csv += i === row.Data.length - 1 ? "\n" : ","
        })
      })
   
      console.log(csv);
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'export.csv';
      hiddenElement.click();
    }
  }
</script> 
<style>
  table.sql td { 
    border-collapse: collapse;
    border: 1px solid grey;
  } 
</style>

Queries allow dataset to be joined and extracted for download or to form new datasets.

<div class="p-2" style="background-color: #0001">
  <div class=""  style="display: inline-block">
    <Button size="sm" on:click={createQuery}>New</Button>
  </div>
<!--
  <div class="float-right" style="display: inline-block">
    <span>{selected.length} selected</span>&nbsp;&nbsp;
    <Button size="sm" on:click={recSelected} disabled={selected.length != 2}>Rec selected</Button>
  </div>
-->
</div>


Current:
{#if !settings.queries || settings.queries.length == 0}
  None
{:else}
  {#each settings.queries as query}
    <Card body>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText class='inputPrefix'>Name</InputGroupText>
        </InputGroupAddon>
        <Input bind:value={query.name}  />
      </InputGroup>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText class='inputPrefix'>SQL</InputGroupText>
        </InputGroupAddon>
        <Input bind:value={query.sql}  />
      </InputGroup>
      <Button size="lg" on:click={() => execQuery(query)}>Run</Button>
      <Button size="pl-2 lg" on:click={() => download(query)}>Download</Button>
      {#if results[query.id] }
      <!-- <div class="row">
        <div class="col-sm">
          <div class="card p-2"> -->
            <table class="sql">
<!--
              <tr>
              {#each results[query.id].ResultSet.Rows[0].Data as value}
                <td>{Object.values(value)[0]}</td>
              {/each}
              </tr>
-->
              {#each results[query.id].ResultSet.Rows as row}
              <tr>
                {#each row.Data as cell}
                  <td>{Object.values(cell)[0] || ""}</td>
                {/each}
              </tr>
              {/each}
            </table>
          <!-- </div>
        </div>
      </div> -->
      {/if}
</Card>
  {/each}
{/if}
